export interface IProductCharacteristics {
    name: string;
    value: string;
    id: number;
}

export function GetCharacteristicsFromString(json: string): IProductCharacteristics[] {
    return json ? JSON.parse(json) as IProductCharacteristics[] : [];
}

export function SetCharacteristicsToString(characteristics: IProductCharacteristics[]): string {
    return JSON.stringify(characteristics);
}